import {
    EDIT_REMINDER_START,
    EDIT_REMINDER_SUCCESS,
    EDIT_REMINDER_FAILED
} from '../../../constants';
import { EDIT_REMINDER_URL } from '../../../../../config/constants';
import { ApiBase } from '../../../../utils/apiBase';
import { withType } from '../../../../utils/actionOperations';
import { toast } from '../../../../utils/messageUtils';
import constants from './constants';

export const editReminder = (payload, callback) => {
    const apiBaseInstance = new ApiBase();
    return dispatch => {
        dispatch(withType(EDIT_REMINDER_START, {}));
        apiBaseInstance.instance
            .post(EDIT_REMINDER_URL, payload)
            .then(response => {
                toast.success(constants.EDIT_REMINDER_SUCCESS_MESSAGE);
                dispatch(withType(EDIT_REMINDER_SUCCESS, {
                    data: response.data,
                    message: response.message
                }));
                callback && callback();
            })
            .catch(err => {
                toast.error(constants.EDIT_REMINDER_FAILURE_MESSAGE);
                dispatch(withType(EDIT_REMINDER_FAILED, {
                    error: err
                }));
            });
    };
};

